// login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const GETVERIFYCODE_REQUEST = 'GETVERIFYCODE_REQUEST';
export const GETVERIFYCODE_SUCCESS = 'GETVERIFYCODE_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGIN_ERROR_MESSAGES = 'LOGIN_ERROR_MESSAGES';
export const LOGIN_LOAD_TAB = 'LOGIN_LOAD_TAB';
export const LOGIN_UPDATE_FREEZETIME = 'LOGIN_UPDATE_FREEZETIME';

// identity
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';

// articles
export const GET_ARTICLE_TAGS = 'GET_ARTICLE_TAGS';
export const UPDATE_ARTICLE_TAGS = 'UPDATE_ARTICLE_TAGS';
export const UPDATE_ARTICLE_IMAGES = 'UPDATE_ARTICLE_IMAGES';
export const UPDATE_ARTICLE_MODEL = 'UPDATE_ARTICLE_MODEL';
export const UPDATE_ARTICLE_LIST = 'UPDATE_ARTICLE_LIST';
export const GET_ARTICLES_SUCCESS = 'GET_ARTICLES_SUCCESS';
export const DELETE_ARTICLE_SUCCESS = 'DELETE_ARTICLE_SUCCESS';
export const RESET_ARTICLE_MODEL = 'RESET_ARTICLE_MODEL';

// JOBOWNER job
export const GET_JOBOWNERJOB_GUILDS = 'GET_JOBOWNERJOB_TAGS';
export const UPDATE_JOBOWNERJOB_GUILD = 'UPDATE_JOBOWNERJOB_TAGS';
export const UPDATE_JOBOWNERJOB_USER = 'UPDATE_JOBOWNERJOB_USER';
export const UPDATE_JOBOWNERJOB_IMAGES = 'UPDATE_JOBOWNERJOB_IMAGES';
export const UPDATE_JOBOWNERJOB_MODEL = 'UPDATE_JOBOWNERJOB_MODEL';
export const DELETE_JOBOWNERJOB_SUCCESS = 'DELETE_JOBOWNERJOB_SUCCESS';
export const RESET_JOBOWNERJOB_MODEL = 'RESET_JOBOWNERJOB_MODEL';

// SERVICE job
export const GET_SERVICE_SERVICETYPES = 'GET_SERVICE_SERVICETYPES';
export const UPDATE_SERVICE_SERVICETYPE = 'UPDATE_SERVICE_SERVICETYPE';
export const UPDATE_SERVICE_IMAGES = 'UPDATE_SERVICE_IMAGES';
export const UPDATE_SERVICE_MODEL = 'UPDATE_SERVICE_MODEL';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const RESET_SERVICE_MODEL = 'RESET_SERVICE_MODEL';
export const UPDATE_SERVICE_LIST = 'UPDATE_SERVICE_LIST';

// Widgets
export const GET_WIDGETS_SUCCESS = 'GET_WIDGETS_SUCCESS';
export const DELETE_WIDGET_SUCCESS = 'DELETE_WIDGET_SUCCESS';

// Search Layout
export const LOAD_SEARCH_LAYOUT = 'LOAD_SEARCH_LAYOUT';

// Dashboard Layout
export const LOAD_DASHBOARD_LAYOUT = 'LOAD_DASHBOARD_LAYOUT';
export const LOAD_DASHBOARD_TITLE = 'LOAD_DASHBOARD_TITLE';
export const LOAD_DASHBOARD_COMPLETED = 'LOAD_DASHBOARD_COMPLETED';
export const UPDATE_DASHBOARD_TAGS = 'UPDATE_DASHBOARD_TAGS';
export const ALERT = 'ALERT';

export const TEST = 'TEST';



/** WEBPACK FOOTER **
 ** ./src/actions/action-types.js
 **/